"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _BestBuysTablePane = _interopRequireDefault(require("./BestBuysTablePane.vue"));
var _BestBuysConfigPane = _interopRequireDefault(require("./BestBuysConfigPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'best_buys',
  components: {
    BestBuysTablePane: _BestBuysTablePane.default,
    BestBuysConfigPane: _BestBuysConfigPane.default
  },
  data: function data() {
    return {
      activeName: 'table',
      bestBuysFnId: null
    };
  },
  created: function created() {},
  methods: {
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.bestBuysTable.search();
    },
    handleAddActivity: function handleAddActivity() {
      this.activeName = 'config';
    },
    handleEditActivity: function handleEditActivity(bestBuysFnId) {
      this.activeName = 'config';
      this.bestBuysFnId = bestBuysFnId;
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'table') {
        this.bestBuysFnId = null;
      }
    }
  }
};